import { GlobalAxios } from "../axios/axios-config";

const TICKET_CALENDAR_EXAM_ATTACHMENT_ROUTE =
  process.env.REACT_APP_TICKETS +
  "/api/v1/TicketCalendarExamAttachmentLog/ResetRetries/";

export const restartTicketCalendarExamAttachmentLogRetries = ({
  id,
}: {
  id: string;
}) => {
  return GlobalAxios.put(TICKET_CALENDAR_EXAM_ATTACHMENT_ROUTE + id, {
    id,
  });
};
